@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Fasiliteter</h2>
    @if (this.filterForm().expanded().value()) {
        <div class="info-tooltip" (click)="facilitiesTooltip.show = !facilitiesTooltip.show" (clickOutside)="facilitiesTooltip.show = false">
            <ev_tooltip
                title="{{ facilitiesTooltip.header }}"
                [visible]="facilitiesTooltip.show"
                [left]="1"
                [bottom]="35"
                [arrowTopAlign]="143"
                [arrowAlignLeft]="81"
                [arrow]="'none'"
            >
                <div class="rentalToolTip">
                    Dekningsgraden av denne informasjonen kan variere. Vi har for eksempel informasjon om at det finnes balkong på en rekke boliger, men det
                    betyr ikke at de resterende boligene mangler balkong. Velger du filter for balkong vil det altså være balkong på alle i utvalget, men det
                    vil helt sikkert være balkong på andre boliger også.
                </div></ev_tooltip
            >
        </div>
    }
    <div class="expander facilitiesTypes" [class.expanded]="this.filterForm().expanded().value()">
        <div class="container">
            <div class="left">
                <ul>
                    @for (facilityType of this.filterForm().facilitiesTypes; track $index) {
                        <li class="check-box" (click)="toggleSelectedFacilityType(facilityType().value())">
                            <input
                                type="checkbox"
                                class="checkbox-icon"
                                [formField]="facilityType.selected"
                                [class.selected]="facilityType.selected().value()"
                            />
                            <label> {{ facilityType.displayText().value() }} </label>
                        </li>
                    }
                </ul>
            </div>
            <div class="right">
                <div class="select-all-btn" [attr.data-cy]="'click-all'" (click)="selectAllFacilityTypes()">
                    <label>Alle</label>
                </div>
            </div>
        </div>
    </div>
}
